/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppEmbeddedSignupStatusPathParams,
	WhatsAppEmbeddedSignupStatusResponse,
} from '../types/WhatsAppEmbeddedSignupStatus'

/**
 * GET /organisations/:organisationId/whatsapp-account/signup/status
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::status
 */
export async function whatsAppEmbeddedSignupStatus(
	organisationId: WhatsAppEmbeddedSignupStatusPathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppEmbeddedSignupStatusResponse>> {
	return axiosInstance.get(`/organisations/${organisationId}/whatsapp-account/signup/status`, config)
}
